exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2YuVJIRLRnqEc3{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:14px;color:#6b778c;width:100%;border:0}._2YuVJIRLRnqEc3 ._2PZEVkKrxNAU_n>td{padding-bottom:15px;border:0}._2YuVJIRLRnqEc3 ._2PZEVkKrxNAU_n:last-of-type>td{padding-bottom:5px}._2YuVJIRLRnqEc3 ._3G6ZzGQRaSOTOl{font-weight:700;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:175px}._2YuVJIRLRnqEc3 ._1lrmu9z3I7qukS{text-align:right}._2YuVJIRLRnqEc3 ._1lrmu9z3I7qukS a{font-size:12px;font-weight:400;color:#172b4d}._2KcI0m6X0yUpQT{cursor:pointer;text-decoration:underline}.hQi9ODTeUmrZT7{padding:0 12px 2px}", ""]);

// exports
exports.locals = {
	"cbdtlContainer": "_2YuVJIRLRnqEc3",
	"row": "_2PZEVkKrxNAU_n",
	"name": "_3G6ZzGQRaSOTOl",
	"link": "_1lrmu9z3I7qukS",
	"bannerLink": "_2KcI0m6X0yUpQT",
	"popoverContent": "hQi9ODTeUmrZT7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/closed-boards-dialog/closed-boards-dialog.less
// module id = Gc4C
// module chunks = 24